import { CreateOrUpdateBaseService } from '../../../../../common/services/createOrUpdateBase.service';
import { services } from '../../../../../constants/services';

export class CreateOrUpdatePermissionService extends CreateOrUpdateBaseService<any, any> {
  constructor(roleId: number | string) {
    super();
    this.url = `${services.roles}/${roleId}/permissionss`;
  }
}
